import moment from 'moment';
import { formatText } from '@/common/utilities';
import dealPermissions from '@/mixins/dealPermissions';
import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import InputDigits from '@/components/InputDigits';
import localReferences from '@/helpers/localReferences';

export const cardMixin = {
    mixins: [
        dealPermissions
    ],
    components: {
        AutoNumeric,
        InputDigits
    },
    data() {
        return {
            numericOptions: {
                digitGroupSeparator: ' ',
                decimalCharacter: ',',
                decimalPlaces: 0,
                decimalCharacterAlternative: '.',
                roundingMethod: 'U',
                minimumValue: '-9999999',
                maximumValue: '9999999',
                isCancellable: true,
                emptyInputBehavior: 'null',
                modifyValueOnWheel: false
            },
            localReferences
        };
    },
    computed: {
        editMode() {
            return this.$route.meta.editMode || false;
        },
        errors() {
            return this.$store.state.deals.errors;
        },
        statusId() {
            return this.$store.state.deals.current.status_id;
        },
        canViewDateFired() {
            return this.$store.getters.isShowFiredEmployers;
        },
        responsibleList() {
            if (this.canViewDateFired) {
                return this.filterFiredEmployers(this.$store.state.references.employers);
            }
            return this.$store.state.references.employers;
        }
    },
    methods: {
        getItemFromLisById(id, list) {
            return Object.keys(list).length && +id ? list.find(item => item.id === +id) : {};
        },
        convertToInt(value) {
            return value ? parseInt(value.toString().replace('.', '')) : value;
        },
        isValueVisible(value, fieldName = null, editMode = null) {
            let valueIsSet = false;
            if (editMode === null) {
                editMode = this.editMode;
            }
            if (editMode && fieldName === null) {
                return true;
            }
            if (value) {
                if (typeof value === 'string') {
                    valueIsSet = value !== '';
                }
                if (typeof value === 'boolean') {
                    valueIsSet = value;
                }
                if (typeof value === 'number') {
                    valueIsSet = value !== 0;
                }
                if (typeof value === 'object') {
                    if (Array.isArray(value)) {
                        valueIsSet = value.length !== 0;
                    } else {
                        valueIsSet = Object.keys(value).length !== 0;
                    }
                }
            }
            if (fieldName) {
                if (valueIsSet) {
                    return this.canViewField(fieldName);
                } else if (editMode) {
                    return this.canEditField(fieldName);
                }
            }
            return valueIsSet;
        },
        cutString(str) {
            if (str.length > 34) {
                return str.substr(0, 34) + '...';
            }
            return str;
        },
        isFiredEmployerClass(dateFired) {
            return dateFired ? 'fired_employer' : '';
        },
        filterFiredEmployers(employers) {
            return employers.filter(employer => !employer.date_fired);
        },
        formatText
    },
    filters: {
        formatDate(date) {
            return date ? moment(date).format('DD.MM.YYYY') : '';
        },
        formatDateTime(date) {
            return date ? moment(date).format('DD.MM.YYYY HH:mm') : '';
        },
        formatFinance(num) {
            return +num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') : '';
        }
    }
};
